
import { createContext, useContext, useState } from 'react';

export const KeylistenerContext = createContext({keyPressed : null, setKeyPressed : (l) => {console.log(l);}});

export const useKeyListener = () => {
	const state = useContext(KeylistenerContext);
	return state.keyPressed;
};